import React from 'react';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';
import { LaunchDarklyProvider } from 'context/LaunchDarklyProvider';
import App from './App';

const tagManagerArgs = {
  gtmId: 'GTM-MDJS8L',
};

TagManager.initialize(tagManagerArgs);

ReactDOM.render(
  <React.StrictMode>
    <LaunchDarklyProvider>
      <App />
    </LaunchDarklyProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
